import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from "@angular/core";
import { SvgHelper } from "@app/shared";

@Component({
  selector: "[shadow-type-1]",
  templateUrl: "./shadow-type-1.component.html",
  styleUrl: "./shadow-type-1.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ShadowType1Component {
  height = input<number>();

  shadowPoints = [238, 533, 108, 530, 135, 428, 259, 304, 454, 416];
  multiplier = 0.27;

  shadowPath = computed(() => {
    const delta = SvgHelper.calculateDelta(this.height(), this.multiplier);
    return SvgHelper.generateType1ShadowPath(delta, this.shadowPoints);
  });
}
